import { createFileRoute } from "@tanstack/react-router";
import MediaPage from "@/features/media/MediaPage";

export const Route = createFileRoute("/_admin/media/")({
  component: MediaPage,
});
